/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.footer",
    title: "Email Footer",
    description: "Gray footer box with transactional message and legal links for platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "transactional": {
            title: "Transactional",
            type: "boolean",
            description: "When true, shows a note explaining this is a security/transactional email. When false, a default unsubscribe mesage and link is shown instead.",
            required: false,
            default: true
        },
        "message": {
            title: "Message",
            type: "string",
            description: "The footer message explaining why the user received this email.",
            required: false,
            default: ""
        },
        "suppressUnsub": {
            title: "Suppress Unsubscribe Line",
            type: "boolean",
            description: "When true, this footer renders attribution + Codex + copyright ONLY — no unsubscribe line. Set by the compiler on marketing emails, where a dedicated email.unsubscribe block (tracked link + CAN-SPAM address) is the single source of unsubscribe. Prevents a duplicate unsubscribe link.",
            required: false,
            default: false
        }
    }
});

var $ = require("../../../uam/scafolding.js");
var urls = require("../email/urls.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.footer",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var transactional = (options && typeof options.transactional !== "undefined") ? options.transactional : true;
    var suppressUnsub = !!(options && options.suppressUnsub);
    var message       = (options && options.message) ? options.message : "";
    var cfg = $.config;
    // PUBLIC email origin only (uat/src/email/urls.js) — never config.my.app.url,
    // which is the ENV host (e.g. ….test) and dead in a recipient's inbox.
    var appUrl    = urls.emailBaseUrl(cfg);
    var appName   = (cfg.my && cfg.my.app && cfg.my.app.name) ? cfg.my.app.name : "The Universe";
    // The platform mark, its link and the Codex are EGT's, not the tenant's, so they
    // always point at egt.studio (tenant sites don't serve /legal/codex or EGT's logo).
    // Tenant-owned links (unsubscribe) still use the tenant's PUBLIC email origin and
    // FAIL CLOSED: with no public origin configured we never emit a dead/dev href.
    var codexUrl    = "https://egt.studio/legal/codex";
    var universeUrl = "https://egt.studio/";
    var logoUrl     = "https://egt.studio/logo.png";

    var transactionalNote = "";
    var textTransactionalNote = "";
    if (transactional) {
        transactionalNote = `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
      This is a transactional or security email. You cannot unsubscribe from these types of emails as they are not a subscription.
    </p>`;
        textTransactionalNote = "This is a transactional or security email. You cannot unsubscribe from these types of emails as they are not a subscription.\n";
    }

    var messageHtml = message
        ? `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">${message}</p>`
        : "";


    // On marketing emails the compiler sets suppressUnsub:true because a dedicated
    // email.unsubscribe block (tracked link + CAN-SPAM address) follows this footer
    // and is the single source of unsubscribe — avoids a duplicate unsubscribe link.
    // FAIL CLOSED on the URL: with no public origin configured we still say the
    // sentence, but we never emit a relative/dev href that dies in an inbox.
    var showUnsub = !transactional && !suppressUnsub;
    var unsubHref = appUrl ? (appUrl + "/email/unsubscribe") : "";
    var unsubWord = unsubHref
        ? `<a href="${unsubHref}" style="color:#6C757D;text-decoration:underline;">unsubscribe</a>`
        : "unsubscribe";
    var unsubscribeHtml = showUnsub
        ? `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
      You can ${unsubWord} from these emails if you no longer wish to receive them. If you have an account, for security, you will be asked to login to manage your email preferences.
    </p>`
        : "";
    var textUnsubscribe = showUnsub
        ? ("You can unsubscribe from these emails if you no longer wish to receive them"
            + (unsubHref ? (": " + unsubHref) : ".") + "\n")
        : "";

    // Optional trademark attribution (my.app.trademarkNotice). Absent = nothing
    // rendered, so tenants that don't set it get the same bytes as before.
    var tmNotice = (cfg.my && cfg.my.app && typeof cfg.my.app.trademarkNotice === "string") ? cfg.my.app.trademarkNotice.trim() : "";
    var tmHtml = tmNotice
        ? `
          <p style="margin:8px 0 0 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">${tmNotice.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}</p>`
        : "";

    var html = `<tr>
  <td style="padding:20px;">
    <table width="100%" border="0" cellpadding="0" cellspacing="0"
           style="background:#1A1A1A;border-radius:4px;">
      <tr>
        <td style="padding:20px;">
          ${messageHtml}
          ${transactionalNote}
          ${unsubscribeHtml}
          <p style="margin:0 0 10px 0;padding:0;text-align:center;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#FFFFFF;">
            Built on
            ${universeUrl
              ? `<a href="${universeUrl}" style="color:#FFFFFF;text-decoration:none;border:none;outline:none;">
              <img src="${logoUrl}" alt="EGT Universe Logo TM" width="16" height="16" style="border:none;outline:none;display:inline-block;vertical-align:text-bottom;width:16px;height:16px;">
              The Universe Platform by EGT.
            </a>`
              : `The Universe Platform by EGT.`}
          </p>
          <p style="margin:0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
            Subject to the Terms of Service and Privacy Policy contained in
            ${codexUrl
              ? `<a href="${codexUrl}" style="color:#6C757D;text-decoration:underline;">The Universe Codex</a>`
              : `The Universe Codex`}.
          </p>
          <p style="margin:8px 0 0 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
            &copy; ${new Date().getFullYear()} ${appName}. All rights reserved.
          </p>${tmHtml}
        </td>
      </tr>
    </table>
  </td>
</tr>`;

    var text = [
        message || "",
        textTransactionalNote,
        textUnsubscribe,
        "Built on The Universe Platform by EGT.",
        (codexUrl
            ? `The Universe Codex (Terms of Service & Privacy Policy): ${codexUrl}`
            : "The Universe Codex (Terms of Service & Privacy Policy)"),
        `\u00A9 ${new Date().getFullYear()} ${appName}. All rights reserved.`,
        tmNotice
    ].filter(function(s) { return s.trim() !== ""; }).join("\n");

    return { html, text };
};
